// JsFromRoutes CacheKey aadfde6b340c5a4f382281c286cfa557
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/admin/settings'),
}
